import { State } from '../../features/types'

export const selectDanfeState = (state: State) => state.danfe
